import React from 'react'

function Footer() {
  return (
    <div className="text-center pb-100 mt-100 border-t dark:border-gray-700 border-gray-200 mt-0">
      <h1 className='text-2xl'>Tonie Search, Inc</h1>
    </div>
  )
}

export default Footer